import Vue from 'vue';
import Vuex from 'vuex';

import ItemCard from './modules/ItemCard'
import Auth from './modules/Auth'
import Navigation from './modules/Navigation'
import Reporting from './modules/Reporting'
import BuyTracker from './modules/BuyTracker/'
import ItemInfo from './modules/ItemInfo'
import ProductCollection from './modules/ProductCollection'
import PowerScan from './modules/PowerScan'

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        ItemCard,
        Auth,
        Navigation,
        Reporting,
        BuyTracker,
        ItemInfo,
        ProductCollection,
        PowerScan
    }
});

store.$app = app;
